import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import MenuPack from '../../components/MenuPack';

const Menu = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <section className="page-section">
            <Container>
                <div className="bg-img">
                    <h2 className="pageTitle">Menu</h2>
                </div>
                <MenuPack />
            </Container>
        </section>
    );
};

export default Menu;
